export const cargarEliminarPrestacion = (modalEliminarPrestacion) => ({
  type: "CARGAR_ELIMINAR_PRESTACION",
  modalEliminarPrestacion,
});

export const cargarEditarPrestacion = (modalEditarPrestacion) => ({
  type: "CARGAR_EDITAR_PRESTACION",
  modalEditarPrestacion,
});

export const SeleccionarPrestacionEliminar = (idPrestacionEliminar) => ({
  type: "CAMBIAR_PRESTACION_ELIMINAR",
  idPrestacionEliminar,
});

export const SeleccionarPrestacionEditar = (idPrestacionEditar) => ({
  type: "CAMBIAR_PRESTACION_EDITAR",
  idPrestacionEditar,
});


export const OpenEliminarPrestacion = () => (dispatch) => {
  dispatch(cargarEliminarPrestacion(true));
};

export const CloseEliminarPrestacion = () => (dispatch) => {
  dispatch(cargarEliminarPrestacion(false));
};

export const OpenEditarPrestacion = () => (dispatch) => {
  dispatch(cargarEditarPrestacion(true));
};

export const CloseEditarPrestacion = () => (dispatch) => {
  dispatch(cargarEditarPrestacion(false));
};
